import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-656645a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-dialog-style-wrap" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_ui_page = _resolveComponent("ui-page")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_table, {
      data: _ctx.source.list,
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "title",
          width: "180"
        }, {
          header: _withCtx(() => [
            (_ctx.options.multiple)
              ? (_openBlock(), _createBlock(_component_el_checkbox, {
                  key: 0,
                  class: "name-check-box",
                  "model-value": _ctx.checkAll,
                  indeterminate: _ctx.checkIndeter,
                  onChange: _ctx.toggleAll
                }, null, 8, ["model-value", "indeterminate", "onChange"]))
              : _createCommentVNode("", true),
            _createTextVNode(" 名称 ")
          ]),
          default: _withCtx(({ row }) => [
            (_ctx.options.multiple)
              ? (_openBlock(), _createBlock(_component_el_checkbox, {
                  key: 0,
                  class: "name-check-box",
                  onChange: ($event: any) => (_ctx.toggle(row, $event)),
                  "model-value": _ctx.checkList[row.id]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onChange", "model-value"]))
              : (_openBlock(), _createBlock(_component_el_radio, {
                  key: 1,
                  label: true,
                  class: "name-check-box",
                  "model-value": _ctx.checkList[row.id],
                  onChange: ($event: any) => (_ctx.toggle(row, $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.name), 1)
                  ]),
                  _: 2
                }, 1032, ["model-value", "onChange"]))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "等级",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(" VIP" + _toDisplayString(row.level), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "创建时间",
          align: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.$format(row.createTime)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_ui_page, {
      style: {"margin-top":"20px"},
      info: _ctx.pageInfo,
      modelValue: _ctx.page.page,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page.page) = $event))
    }, {
      default: _withCtx(() => [
        _createTextVNode("已选择 " + _toDisplayString(_ctx.list.length) + " 个组", 1)
      ]),
      _: 1
    }, 8, ["info", "modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.choose
      }, {
        default: _withCtx(() => [
          _createTextVNode("提交")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}